module.exports = __webpack_public_path__ + "static/media/noAirBaloon.ff8eee80.png";